import React, { useState } from 'react';
import './SearchFilter.css';

interface SearchFilterProps {
  onFilter: (searchTerm: string) => void;
  onSort: (sortBy: 'title' | 'createdAt' | 'updatedAt', sortOrder: 'asc' | 'desc') => void;
}

export const SearchFilter: React.FC<SearchFilterProps> = ({ onFilter, onSort }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState<'title' | 'createdAt' | 'updatedAt'>('createdAt');
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('desc');

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    onFilter(value);
  };

  const handleSortChange = (newSortBy: 'title' | 'createdAt' | 'updatedAt') => {
    let newSortOrder = sortOrder;
    if (sortBy === newSortBy) {
      newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      newSortOrder = newSortBy === 'title' ? 'asc' : 'desc';
    }
    
    setSortBy(newSortBy);
    setSortOrder(newSortOrder);
    onSort(newSortBy, newSortOrder);
  };

  const clearSearch = () => {
    setSearchTerm('');
    onFilter('');
  };

  return (
    <div className="search-filter">
      <div className="search-section">
        <div className="search-input-container">
          <input
            type="text"
            placeholder="Search reports..."
            value={searchTerm}
            onChange={handleSearchChange}
            className="input search-input"
          />
          {searchTerm && (
            <button onClick={clearSearch} className="clear-search-btn" type="button">
              ✕
            </button>
          )}
        </div>
      </div>

      <div className="sort-section">
        <span className="sort-label">Sort by:</span>
        <div className="sort-buttons">
          <button
            onClick={() => handleSortChange('title')}
            className={`sort-btn ${sortBy === 'title' ? 'active' : ''}`}
          >
            Title {sortBy === 'title' && (sortOrder === 'asc' ? '↑' : '↓')}
          </button>
          <button
            onClick={() => handleSortChange('createdAt')}
            className={`sort-btn ${sortBy === 'createdAt' ? 'active' : ''}`}
          >
            Created {sortBy === 'createdAt' && (sortOrder === 'asc' ? '↑' : '↓')}
          </button>
          <button
            onClick={() => handleSortChange('updatedAt')}
            className={`sort-btn ${sortBy === 'updatedAt' ? 'active' : ''}`}
          >
            Updated {sortBy === 'updatedAt' && (sortOrder === 'asc' ? '↑' : '↓')}
          </button>
        </div>
      </div>
    </div>
  );
};
